import React from 'react';

import FieldHistoryReport from '../shared/fieldHistory/FieldHistoryReport';

import type { DealInformationTab } from './types';
import { useDealFieldHistory } from './useDealFieldHistory';

const REPORT_PAGE_SIZE = 100;

interface Props {
  activeTab: DealInformationTab;
  onBack: () => void;
  opportunityId: string | undefined;
}

export default function DealFieldHistoryReport({ activeTab, onBack, opportunityId }: Props) {
  const { entries, error, isLoading, lastUpdatedAt, totalCount } = useDealFieldHistory(
    activeTab,
    opportunityId,
    REPORT_PAGE_SIZE,
  );

  return (
    <FieldHistoryReport
      backLabel="Details"
      entries={entries}
      error={error}
      isLoading={isLoading}
      lastUpdatedAt={lastUpdatedAt}
      onBack={onBack}
      title="Opportunity Field History"
      totalCount={totalCount}
    />
  );
}
